import { useMemo } from 'react';
import { ReturnItem, ReturnRecord } from './ReturnItem';

interface CommonOrderReturnProps {
  storeId: string;
  order: Conversation.Trade.Vo;
  onUpdate: () => void;
}

export const CommonOrderReturn = (props: CommonOrderReturnProps) => {
  const { order, storeId, onUpdate } = props;
  const { items, platform, unit, externalShopId, internalTradeId, externalTradeId, region } = order;

  const returnRecord = useMemo(() => {
    const record = new Map<string, ReturnRecord>();
    items.forEach((item) => {
      if (item.refundReason?.length) {
        item.refundReason.forEach((refundReason) => {
          const { returnSn, displayStatus } = refundReason;
          if (returnSn) {
            const existingRecord = record.get(returnSn);
            if (existingRecord) {
              existingRecord.items.push(item);
            } else {
              record.set(returnSn, {
                unit,
                platform,
                internalStoreId: storeId,
                externalStoreId: externalShopId,
                internalTradeId,
                externalTradeId,
                region,
                returnSn,
                displayStatus,
                refundReason,
                items: [item],
              });
            }
          }
        });
      }
    });
    return record;
  }, [externalShopId, externalTradeId, internalTradeId, items, platform, region, storeId, unit]);

  const keys = useMemo(() => {
    return Array.from(returnRecord.keys());
  }, [returnRecord]);

  return (
    <>
      {keys.map((key) => {
        const record = returnRecord.get(key)!;
        return <ReturnItem key={key} {...record} onUpdate={onUpdate} />;
      })}
    </>
  );
};
